import { fr, enGB, arTN } from "date-fns/locale";
import uiI18n from "../i18n";
import React, { useState, useEffect } from "react";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import citiesAndDelegations from '../data/citiesAndDelegations.js';
import ImageSlider from '../components/ImageSlider.jsx';
import { useTranslation } from 'react-i18next';
import Spinner from '../components/Spinner.jsx';
import ListPartyRooms from "../components/ListPartyRooms.jsx";
import { toast } from 'react-toastify';
import { getAllVacations } from '../Services/vacationsService.jsx';
import { getVacations } from '../Services/vacationsService.jsx';

export default function PartyRooms() {
  const { t } = useTranslation();
  const [destination, setDestination] = useState('');
  const [travelers, setTravelers] = useState('');
  const [vacations, setVacations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(0);
  const resetStartDate = () => setStartDate(null);
  const [startDate, setStartDate] = useState('');
  const [reservedDates, setReservedDates] = useState([]);
  const today = new Date().toISOString().split('T')[0];

  const filters = {
    city: destination,
    travelers,
  };

  const fetchVacations = async () => {
    setLoading(true);
    try {
      const response = await getVacations(0,filters);
         setVacations(response);
         setHasMore(response.length === 20); // Suppose 20 éléments par page
    } catch (error) {
      toast.error(t('errorFetchingVacations'));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVacations(0, true);
  }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    setPage(0);
    fetchVacations(0, true);
  };

  const onFetchMoreListings = async () => {
    try {
      const pageNumber = page + 1;
      const response = await getVacations(pageNumber, filters);
      setVacations(prevListings => [...prevListings, ...response]);
      setHasMore(response.length === 20);
      setPage(pageNumber);
    } catch (error) {
      console.error('Une erreur s\'est produite :', error);
    }
  };


  const handleReset = () => {
    setDestination('');
    setTravelers('');
    setPage(0);
    fetchVacations(0, true);
  };

  return (
    <div>
      <div className="items-center justify-center flex">
        <form onSubmit={handleSearch} className="flex mx-auto items-center gap-4 p-4 rounded-lg">
          <div className="flex flex-col">
            <label className="mb-1 ms-2">{t('city')}</label>
            <select
              value={destination}
              onChange={(e) => setDestination(e.target.value)}
              className="w-full md:w-auto rounded-l-full px-4 py-2 text-gray-800"
            >
              <option value="">{t('city')}</option>
              {Object.keys(citiesAndDelegations).map((city) => (
                <option key={city} value={city}>
                  {city}
                </option>
              ))}
            </select>
          </div>
          <div className="flex flex-col">
              <label htmlFor="startDate" className="text-sm font-semibold">{uiI18n.t("ui.date")}</label>
            <div>
              <DatePicker
                    locale={uiI18n.language.startsWith("ar") ? arTN : uiI18n.language.startsWith("en") ? enGB : fr}
                    previousMonthButtonLabel={uiI18n.t("ui.previous_month")}
                    nextMonthButtonLabel={uiI18n.t("ui.next_month")}

                className="border border-gray-300 rounded p-2"
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                excludeDateIntervals={reservedDates.map(d => ({ start: new Date(d.startDate), end: new Date(d.endDate) }))}
                minDate={today}
               />
               {startDate && (
                <button
                    onClick={resetStartDate}
                   className=" text-red-500 hover:text-red-700"
                >
                    ✕
                </button>
            )}</div>
            </div>
          <div className="flex flex-col">
            <label className="mb-1">{t('guestNumbers')}</label>
            <input
              type="number"
              value={travelers}
              onChange={(e) => setTravelers(e.target.value ? parseInt(e.target.value, 10) : '')}
              min="1"
              max="100"
              className="w-full md:w-auto py-2 text-gray-800"
              placeholder={t('guestNumbers')}
            />
          </div>

          <div className="flex flex-col mt-5">
            <button
              type="submit"
              className="bg-gray-900 w-72 h-12 hover:bg-gray-700 text-white font-bold rounded-l-full"
            >
              {t('search_form.search')}
            </button>
          </div>

          <div className="flex flex-col mt-5 ms-2">
            <button
              type="button"
              onClick={handleReset}
              className="bg-gray-900 w-72 h-12 hover:bg-gray-700 text-white font-bold rounded-r-full"
            >
              {t('search_form.reset')}
            </button>
          </div>
        </form>
      </div>

      <div className="max-w-6xl mx-auto px-3">
        {loading ? (
          <Spinner />
        ) : vacations.length > 0 ? (
          <>
            <main>
              <ul className="sm:grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-4">
                {vacations.map((vacation) => (
                  <ListPartyRooms key={vacation.ID} listing={vacation} />
                ))}
              </ul>
            </main>
            {hasMore && (
              <div className="flex justify-center items-center">
                <button
                  onClick={onFetchMoreListings}
                  className="bg-white px-3 py-1.5 text-gray-700 border border-gray-300 mb-6 mt-6 hover:border-state-600 rounded transition duration-150 ease-in-out"
                >
                  {t('see_plus')}
                </button>
              </div>
            )}
          </>
        ) : (

           <p className="text-center border-t border-gray-700 pt-4"> {uiI18n.t("ui.no_exact_matches")} <p className="text-gray-700 mt-2 mb-4"> {uiI18n.t("ui.change_or_remove_some_filters_or_adjust_your_search_area")} </p>
           {/* {t('noData')} */}
            </p>
        )}
      </div>
    </div>
  );
}
